<template>
  <flexbox class="wk-upload-cell">
    <img
      :src="fileIcon"
      class="wk-upload-cell__header">
    <div class="wk-upload-cell__body">
      <div class="text-one-line">{{ file.name }}<span style="color: #6b778c;">{{ fileSize }}</span></div>
      <el-progress
        :stroke-width="3"
        :show-text="false"
        :percentage="complete ? 100 : percentage" />
    </div>
    <div class="wk-upload-cell__footer">
      <el-button
        :icon="handleIcon"
        @click="cancelRequest" />
    </div>
  </flexbox>
</template>

<script>
import { qiniuUploadAPI, getQiniuTokenAPI, qiniuSaveFileInfoAPI } from '@/api/common'
import { getFileTypeIcon, fileSize } from '@/utils'
import { Bucket } from '@/utils/qiniu'
import store from '@/store'

import axios from 'axios'

export default {
  name: 'WkUploadCell',
  components: {},
  props: {
    file: {
      type: File,
      required: true
    },
    index: Number,
    request: Function,
    complete: {
      type: Boolean,
      default: false
    },
    uploadShow: {
      type: Boolean,
      default: true
    },
    params: Object
  },
  data() {
    return {
      percentage: 0,
      cancel: null
    }
  },
  computed: {
    handleIcon() {
      return this.complete ? 'el-icon-check' : 'el-icon-close'
    },

    fileIcon() {
      return getFileTypeIcon(this.file)
    },

    fileSize() {
      return `（${fileSize(this.file.size)}）`
    },
    qiniuToken() {
      return store.state.crm.qiniuToken
    }
  },
  watch: {
    file: {
      handler() {
        if (this.file && !this.complete && this.percentage == 0) {
          this.uploadFile()
        }
      },
      immediate: true
    }
  },
  mounted() {},

  beforeDestroy() {},
  methods: {
    async uploadFile() {
      const request = this.request ? this.request : qiniuUploadAPI
      const params = this.params ? this.params : {}
      params.file = this.file
      // params.token = 'EQT5Z3nOVS3DZ7vBWTaB-vTN73ATZEhVEyIZzhXI:DHOKVRptPR-RrwBvaVFHZRR-4uQ=:eyJzY29wZSI6Im1pZGRsZXN0YWdlIiwiZGVhZGxpbmUiOjE2NjU5OTY3Njh9'

      if (request === qiniuUploadAPI) {
        if (this.qiniuToken) {
          params.token = this.qiniuToken
        } else {
          const result = await getQiniuTokenAPI({ bucket: Bucket.Default })
          params.token = result.data
          store.commit('SET_QINIU_TOKEN', result.data)
        }

        params.key = new Date().getTime().toString() + Math.floor(Math.random() * 1000000000).toString().slice(0, 6) // 生成19位唯一数字字符串作为key
      }

      const CancelToken = axios.CancelToken

      const self = this
      const config = {
        onUploadProgress: progressEvent => {
          const percentage = (progressEvent.loaded / progressEvent.total * 100 | 0)
          this.percentage = percentage
        },
        cancelToken: new CancelToken(function executor(c) {
          self.cancel = c
          self.$emit('cancelTokenChange', c, self.index)
        })
      }

      request(params, config)
        .then(res => {
          if (request === qiniuUploadAPI) {
            const params = {
              batchId: this.params.batchId,
              size: this.file.size,
              name: this.file.name,
              fileId: res.key,
              type: this.params.type
            }
            if (this.uploadShow) {
              qiniuSaveFileInfoAPI(params).then(({ data }) => {
                this.$emit('completed', this.index, { ...params, file: this.file, batchId: data })
              })
            } else {
              this.$emit('completed', this.index, { ...params, file: this.file })
            }
          } else {
            this.$emit('completed', this.index, res)
          }
        })
        .catch(() => {
          store.commit('SET_QINIU_TOKEN', '')
          this.uploadFile()
          this.$emit('error', this.index)
        })
    },

    cancelRequest() {
      if (!this.complete) {
        this.cancel()
        this.$emit('delete', this.index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wk-upload-cell {
  padding: 8px 15px;
  background-color: #f0f0f0;
  border-radius: 4px;

  &__header {
    flex-shrink: 0;
    width: 17px;
    height: 20px;
    margin-right: 15px;
  }

  &__body {
    flex: 1;
    width: 0;

    .el-progress {
      margin-top: 8px;
    }
  }

  &__footer {
    flex-shrink: 0;
    margin-left: 10px;

    .el-button {
      padding: 0;
      font-weight: bold;
      background: transparent;
      border: none;
      outline: none;

      /deep/ i {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
}
</style>
